// Shared helpers for the Flow and Focus reading modes.
// Splits raw document text into paragraphs and sentences, tracking the running
// word offset so each piece can be mapped back to a reading position.

export const SENTENCE_BOUNDARY = /(?<=[.!?\u3002\uFF01\uFF1F]["')\]]?)\s+/;

export function buildReadingModel(text) {
    const rawParas = (text || "").split(/\n{2,}/).map((p) => p.trim()).filter(Boolean);
    const paragraphs = [];
    const sentences = [];
    let wordCursor = 0;

    rawParas.forEach((para, pIdx) => {
        const parts = para.split(SENTENCE_BOUNDARY).map((s) => s.trim()).filter(Boolean);
        const sentenceList = (parts.length ? parts : [para]).map((s) => {
            const wc = s.split(/\s+/).filter(Boolean).length || 1;
            const item = {
                text: s,
                wordStart: wordCursor,
                wordCount: wc,
                paragraphIndex: pIdx,
                index: sentences.length,
            };
            wordCursor += wc;
            sentences.push(item);
            return item;
        });
        paragraphs.push({ index: pIdx, sentences: sentenceList });
    });

    return { paragraphs, sentences, totalWords: Math.max(1, wordCursor) };
}
